export default {
  page_title: {
    create: 'Create promo code',
    edit: 'Edit promo code',
  },
  navbar: {
    aria_label: 'Promo code form actions',
    configure: 'Configure',
    promo_code: 'Promo code',
    cancel: 'Cancel',
    save_and_exit: 'Save & Exit',
    saving: 'Saving...',
    save: 'Save',
    create: 'Create',
    activate: 'Activate',
    tooltip_name_required: 'Add a promo name',
    tooltip_reward_required: 'Select an offer',
    tooltip_code_required: 'Enter a promo code',
    tooltip_code_count_required: 'Enter the number of codes',
    tooltip_code_count_max: 'Maximum 4,000,000 codes',
    tooltip_time_description_required:
      'Add a customer-facing time-of-day description',
    tooltip_time_description_min_length:
      'Time-of-day description must be at least 5 characters',
    tooltip_time_description_max_length:
      'Time-of-day description must be 47 characters or fewer',
    tooltip_time_description_punctuation:
      'Time-of-day description must not end with punctuation',
    tooltip_time_end_after_start: 'End time must be after start time',
    tooltip_minimum_spend_must_be_positive:
      'Minimum spend must be greater than $0',
  },
  promo_name: {
    placeholder: 'Enter promo name',
    edit: 'Edit promo name',
  },
  validation: {
    name_required: 'Please enter a promo name.',
    reward_required: 'Please select an offer.',
    code_required: 'Please enter a promo code.',
    code_count_required: 'Please enter a valid number of codes.',
    code_count_max: 'Code count cannot exceed 4,000,000.',
    time_description_required:
      'Please add a customer-facing description for the time-of-day restriction.',
    time_description_min_length:
      'Time-of-day description must be at least 5 characters.',
    time_description_max_length:
      'Time-of-day description must be 47 characters or fewer.',
    time_description_punctuation:
      'Time-of-day description must not end with punctuation.',
    time_end_after_start:
      'End time for the time-of-day restriction must be on or after the start time.',
    minimum_spend_must_be_positive:
      'Minimum spend must be greater than $0. Remove the restriction or enter a positive amount.',
  },
  alerts: {
    update_success: 'Promo code updated successfully.',
    update_error: 'Failed to update promo code.',
    create_error: 'Failed to create promo code.',
    create_success_static: 'Promo code created.',
    create_success_unique:
      'Promo code created. Your codes are generating — this may take a few minutes.',
  },
  promo_code_section: {
    title: 'Promo code',
    description: 'Choose how this promo code will be shared and redeemed.',
    single: {
      title: 'Single shared code',
      description:
        'Use one code across emails, ads, partners, or in-store promotions.',
      code_label: 'Code',
      placeholder: 'e.g. SUMMER25',
    },
    unique: {
      title: 'Unique codes',
      description: 'Generate individual codes for one-to-one distribution.',
      count_label: 'Number of codes',
      generation_note:
        'Generation time depends on volume — small batches finish in seconds, larger batches (up to 4,000,000 codes) may take a few minutes.',
    },
  },
  reward_section: {
    title: 'Offer',
    select_prompt: 'Which offer should this promo code apply?',
    select_placeholder: 'Select an offer template…',
    create_new: "Can't find the right offer?",
    create_link: 'Create a new offer',
    view_details: 'View details',
    hide_details: 'Hide details',
    tabs: {
      details: 'Offer details',
      online: 'Online',
      instore: 'In-store',
    },
    details: {
      reward_type: 'Offer type',
      cost_to_business: 'Cost to business',
      retail_price: 'Retail price',
      number_of_uses: 'Number of uses',
      multi_use: 'Multi-use',
      single_use:
        'After this offer is used or expires, no additional offers are issued to the same customer.',
    },
    types: {
      item: 'Get a free item',
      amount: 'Amount off',
      percent: 'Percent off',
      fixed_price: 'Fixed price',
    },
    online: {
      enabled: 'This offer can be redeemed online.',
      disabled: 'Online redemption is not enabled for this offer.',
    },
    instore: {
      enabled: 'This offer can be redeemed in-store.',
      disabled: 'In-store redemption is not enabled for this offer.',
    },
  },
  locations_section: {
    title: 'Participating locations',
    prompt: 'Where can this promo be used:',
    all: 'Select all locations',
    specific: 'Select specific locations',
    group: 'Select a location group',
  },
  redemption_section: {
    title: 'Redemption settings',
    valid_from: 'Promo code will be valid from',
    valid_until: 'Promo code will be valid until',
    restrictions: 'Restrictions',
    add_restriction: 'Add restriction',
    edit: 'Edit',
    minimum_spend: 'Minimum spend',
    maximum_discount: 'Maximum discount',
    minimum_spend_summary: 'Minimum spend: $%{amount}',
    maximum_discount_summary: 'Maximum discount: $%{amount}',
    days_summary: 'Valid on: %{days}',
    time_summary: 'Valid from %{start} to %{end}',
    modal: {
      title: 'Offer restrictions',
      description:
        'Add specific restrictions around how customers can redeem their offer.',
      time_restriction_title:
        'Restrict offer to specific times or days of the week',
      maximum_discount_title: 'Maximum discount',
      maximum_discount_description:
        'Set the maximum discount customers can receive e.g. Customer can get up to $50 off.',
      maximum_discount_placeholder: 'e.g. 50',
      minimum_spend_title: 'Minimum spend',
      minimum_spend_description:
        'Require customers to spend a certain amount in order to receive the discount e.g. Get a free burger when you spend $20 or more.',
      minimum_spend_placeholder: 'e.g. 20',
      days_title: 'Restrict to specific days of the week',
      days_description:
        'Select which days of the week the promo code can be redeemed.',
      time_title: 'Restrict to a specific time of day',
      time_description:
        'Select the start and end hours when the promo code can be redeemed.',
      advanced_locked_banner:
        'This promo has advanced day/time restrictions configured outside the wizard. To edit them, please use the Campaign Builder.',
      time_start_label: 'Start time',
      time_end_label: 'End time',
      time_description_label: 'Customer-facing description',
      time_description_placeholder: 'e.g. Lunch deal',
      time_description_required: 'Description is required.',
      time_description_min_length: 'Description must be at least 5 characters.',
      time_description_max_length:
        'Description must be 47 characters or fewer.',
      time_description_punctuation:
        'Description must not end with punctuation.',
      time_end_after_start: 'End time must be after start time.',
      day_short: {
        monday: 'Mon',
        tuesday: 'Tue',
        wednesday: 'Wed',
        thursday: 'Thu',
        friday: 'Fri',
        saturday: 'Sat',
        sunday: 'Sun',
      },
      okay: 'Okay',
      close: 'Close restrictions modal',
    },
  },
  leave_modal: {
    title: 'Are you sure you want to leave?',
    message:
      "You haven't finished your promo code yet. If you leave now we'll save it as a draft so you can finish it later.",
    save_and_exit: 'Save and Exit',
    finish: 'Finish Promo Code',
  },
  clear_restrictions_modal: {
    title: 'Clear redemption restriction?',
    message:
      "This promo's day-of-week and time-of-day restrictions will be permanently removed. The original schedule cannot be recovered.",
    cancel: 'Cancel',
    confirm: 'Yes, clear it',
  },
  confirm_modal: {
    title: 'Create promo code?',
    title_edit: 'Save changes?',
    name_label: 'Name',
    code_type_label: 'Code type',
    single_code: 'Single shared code: %{code}',
    unique_codes: '%{count} unique codes',
    reward_label: 'Offer',
    cancel: 'Cancel',
    creating: 'Creating...',
    create: 'Create',
    saving: 'Saving...',
    save: 'Save',
  },
}
